
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 2a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1 9 9 0 00-9-9zm1 8V4.07A7 7 0 0119.93 10H14z"}}),_c('path',{attrs:{"d":"M20.82 14.06a1 1 0 00-1.28.61A8 8 0 119.33 4.46a1.001 1.001 0 00-.66-1.89 10 10 0 1012.76 12.76 1 1 0 00-.61-1.27z"}})])
          )
        }
      }
    